import { render } from "./ERPView.vue?vue&type=template&id=5f010cc4"
import script from "./ERPView.vue?vue&type=script&lang=js"
export * from "./ERPView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__